module.exports = __webpack_public_path__ + "static/media/icon-calendar.6fa41d11.svg";